import * as React from 'react';
import { DetailedHTMLProps, HTMLAttributes, ReactElement, useEffect } from 'react';
import styles from './title.module.scss';
import cn from 'classnames';
import { ForceFocus } from '@mo/accessibility';

export type TitleProps = {
    title: string;
    className?: string;
    icon?: ReactElement;
} & DetailedHTMLProps<HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement>;

export const Title: React.FunctionComponent<TitleProps> = ({
    title,
    icon,
    className,
    ...headingProps
}): ReactElement => {
    useEffect((): void => {
        document.title = `${title} - Smart`;
    }, [title]);

    return (
        <ForceFocus focus={true}>
            {icon ? (
                <div className={styles.heading}>
                    <h1 className={cn(className, styles.title)} {...headingProps}>
                        {title}
                    </h1>
                    <div className={styles.iconContainer}>{icon}</div>
                </div>
            ) : (
                <h1 className={className} {...headingProps}>
                    {title}
                </h1>
            )}
        </ForceFocus>
    );
};
